import { Injectable } from "@angular/core";
import { Router, RoutesRecognized } from "@angular/router";
import { AuthenticationService } from "./auth.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
// import { map, catchError } from "rxjs/operators";
// import { of } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class HospitalService {
  base_uri: string;
  filemgr_url: string;
  auth_url: string;
  // decodedToken;
  constructor(
    private router: Router,
    private authService: AuthenticationService,
    private http: HttpClient
  ) {
    this.base_uri = environment.hospital_url;
    // this.decodedToken = this.authService.getDecodedToken();
    this.filemgr_url = environment.filemgr_url;
    this.auth_url = environment.auth_uri;
  }


  getTokenFromURL() {
    let token = null;
    let ref = this;
   var dd = new Promise(function(resolve,reject) {
    const eventsData =   ref.router.events.subscribe(val => {
 
        if (val instanceof RoutesRecognized) {
          if(val && val.state && val.state.root && val.state.root.firstChild && val.state.root.firstChild){
          //  token = val.state.root.firstChild.params['token'];
          token = val.state.root.firstChild.queryParamMap.get('token');
          if(token) {
            resolve(token);
            eventsData.unsubscribe();
            return dd;
          }
          }
        }else if(val['url'] && val['url'] == "/") {
            resolve(false);
            eventsData.unsubscribe();
        }
    });
  });
  return dd;
  }

 async getAlliance() {
    let allianceData = null;
    let ref = this;
   var dd = new Promise(function(resolve,reject) {
  allianceData = ref.getRelatedEntities().subscribe(result => {
    if(result) {
      if(result['data']){
        resolve(result['data']);
        return dd;
      }
    }
  })
  });
  return dd;
  }


  getRelatedEntities() {
    // let decodedToken = this.decodedToken;
    //Add hospital to payload
    let decodedToken = this.authService.getDecodedToken();
    let hospital = decodedToken["hospital"];
    let url = this.base_uri + "hospital/organizations?organization=" + hospital;
    return this.http.get(url, {
      headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.authService.getToken()),
    });
  }


 async getUserAlliance() {
  let allianceData = null;
  let ref = this;
 var dd = new Promise(function(resolve,reject) {
allianceData = ref.getRelatedUser().subscribe(result => {
  if(result) {
    if(result['data']){
      resolve(result['data']);
      return dd;
    }
  }
})
});
return dd;
}


getRelatedUser() {
  // let decodedToken = this.decodedToken;
  //Add hospital to payload
  let decodedToken = this.authService.getDecodedToken();
  let hospital = decodedToken["hospital"];
  let url = this.auth_url + 'user/relation/get_relation';

  return this.http.get(url, {
    headers: new HttpHeaders().set('Authorization', 'Bearer ' + this.authService.getToken()),
  });
}

  // getAlliances() {
  //   let alliances = [];
  //   let item = localStorage.getItem("alliance");
  //   if (item) {
  //     alliances = JSON.parse(item);
  //   }
  //   return alliances;
  // }

  getPanels() {
    let url = this.base_uri + "hospital/panels";
    return this.http.get(url, {
      headers: new HttpHeaders().set(
        "Authorization",
        "Bearer " + this.authService.getToken()
      )
    });
  }

}
